import axios from "axios";
import { BASE_URL } from "../constants";
import getHeaders from "../constants/headers";

 

// User Role

export const getLeadSource = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-source",
    headers: getHeaders(),
  });
};

export const getLeadStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-status",
    headers: getHeaders(),
  });
};
    
 

// lead

export const getLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead-search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateLead = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
 

export const getLeadDocument = (leadId) => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead/" + leadId + "/document",
    headers: getHeaders(),
  });
};

export const addUserLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateUserLead = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};



export const getUserLead = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const userLeadAssign = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/assign",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getUserLeadStatus = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/user-lead-status",
    headers: getHeaders(),
  });
};


export const getLeadType = () => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-type",
    headers: getHeaders(),
  });
};


//  Lead Status


export const getMasterLeadStatus = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/search-lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addMasterLeadStatus = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateMasterLeadStatus = (data) => {
  return axios({
    method: "put",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getLeadStatusApi = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/get-lead-status",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const DeleteLeadData = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/master/delete-lead-data",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getLeadSummary = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/lead-summary",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getUserLeadSummary = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/lead-summary",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getLoanFileSummary = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file-summary",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getLoanFileSummarySearch = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/loan-file/search",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const getUserLeadByRole = (leadId, role) => {
  return axios({
    method: "get",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/lead/" + leadId + "/"+ role,
    headers: getHeaders(),
  });
};

export const getProjectReportFeeInfo = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/project-report-fee-info",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getProjectReportCommitment = (data) => {
  return axios({
    method: "post",
    url: BASE_URL + "/fseva-lead/api/secure/v1/user-lead/project-report-commitment",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// curl --location 'https://apibackoffice.financeseva.com/fseva-lead/api/secure/v1/user-lead/project-report-fee-info' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6IlItQURNTlJIQSIsImVuYWJsZWRSb2xlQWNjZXNzTW9kZWwiOiJubyIsInN1YiI6IjUiLCJpYXQiOjE3OTA1NzA2ODUsImV4cCI6MTc5MTE3NTQ4NX0.65Ovd8fT-GYtqgsSuXge_b6V-N-yBzS8NqJT3-bBec4DNk6MXIp2LKMz77Vj7MruWbMNyC9n7ZCJeYGhrYDXMA' \
// --header 'Cookie: JSESSIONID=A19319222633F2C35DC4A4BB6CA853FF' \
// --header 'Content-Type: application/json' \
// --data '{
//     "leadTypeIn": [
//         "project_report_tev_study_pitch_deck"
//     ],
//     "recordType": "",
//     "startDate": "2025-05-06T11:39:45.347Z",
//     "endDate": "2026-09-29T11:39:45.347Z",
//     "sortBy": "",
//     "sortOrder": "desc",
//     "userIdIn": [],
//     "statusIn": []
// }'

// curl --location 'https://apibackoffice.financeseva.com/fseva-lead/api/secure/v1/user-lead/project-report-commitment' \
// --header 'Authorization: Bearer eyJhbGciOiJIUzUxMiJ9.eyJhdXRob3JpdGllcyI6WyJST0xFX0FETUlOIl0sImRldmljZVRva2VuIjoiZDQxZDhjZDk4ZjAwYjIwNGU5ODAwOTk4ZWNmODQyN2UiLCJsb2dnZWRJblVzZXJJZCI6IlItQURNTlJIQSIsImVuYWJsZWRSb2xlQWNjZXNzTW9kZWwiOiJubyIsInN1YiI6IjUiLCJpYXQiOjE3OTA1NzA2ODUsImV4cCI6MTc5MTE3NTQ4NX0.65Ovd8fT-GYtqgsSuXge_b6V-N-yBzS8NqJT3-bBec4DNk6MXIp2LKMz77Vj7MruWbMNyC9n7ZCJeYGhrYDXMA' \
// --header 'Cookie: JSESSIONID=C73C14DB456A26B93F547B234F2324E2' \
// --header 'Content-Type: application/json' \
// --data '{
//     "leadTypeIn": [
//         "project_report_tev_study_pitch_deck"
//     ],
//     "recordType": "",
//     "startDate": "2026-09-06T11:39:45.347Z",
//     "endDate": "2026-09-29T11:39:45.347Z",
//     "sortBy": "",
//     "sortOrder": "desc",
//     "userIdIn": [],
//     "statusIn": []
// }'